function productFiltersBlockTitle() {
    $(document).on("click", ".product-filters--block--title", function() {
        $(this).toggleClass("title-closed");
        $(this).siblings(".product-filters--block--body").slideToggle();
    });
}

$(document).ready(function() {
    productFiltersBlockTitle();
});
